import { render, staticRenderFns } from "./ShopsMap.vue?vue&type=template&id=6356f7e8&scoped=true"
import script from "./ShopsMap.vue?vue&type=script&lang=js"
export * from "./ShopsMap.vue?vue&type=script&lang=js"
import style0 from "./ShopsMap.vue?vue&type=style&index=0&id=6356f7e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6356f7e8",
  null
  
)

export default component.exports